import { jsx, jsxs } from "react/jsx-runtime";
import { Table } from "@zillow/constellation-10";
import "react";
import { RATE_COMPARES } from "./constants.esm.js";
const MortgageRatesTableHeader = ({
  columns,
  rateCompare
}) => /* @__PURE__ */ jsx(Table.Header, { children: /* @__PURE__ */ jsxs(Table.Row, { children: [
  /* @__PURE__ */ jsx(Table.HeaderCell, { align: "left", css: {
    width: "50%"
  }, children: "Program" }),
  columns.includes("rate") && /* @__PURE__ */ jsx(Table.HeaderCell, { align: "right", children: "Rate" }),
  columns.includes("rateChange") && /* @__PURE__ */ jsxs(Table.HeaderCell, { align: "right", children: [
    RATE_COMPARES[rateCompare],
    " Change"
  ] }),
  columns.includes("apr") && /* @__PURE__ */ jsx(Table.HeaderCell, { align: "right", children: "APR" }),
  columns.includes("aprChange") && /* @__PURE__ */ jsxs(Table.HeaderCell, { align: "right", children: [
    RATE_COMPARES[rateCompare],
    " Change"
  ] })
] }) });
export {
  MortgageRatesTableHeader as default
};
